import clsx from 'clsx';
import { forwardRef } from 'react';

import { progressBarIconContainerCSS } from './ProgressBarIcon.sty.js';
import { type DataTestId } from '../../core/types/data-props.js';
import { type StylingProps } from '../../core/types/styling-props.js';
import { type WithChildren } from '../../core/types/with-children.js';

/**
 * Accepted properties for ProgressBarIcon.
 * @public
 */
export interface ProgressBarIconProps
  extends WithChildren,
    StylingProps,
    DataTestId {}

/**
 * The ProgressBarIcon subcomponent is rendered inside the ProgressBar component.
 * @public
 */
export const ProgressBarIcon = forwardRef<HTMLDivElement, ProgressBarIconProps>(
  (props, forwardedRef) => {
    const {
      children,
      className: consumerClassName,
      style: consumerStyle,
      'data-testid': dataTestId,
      ...remainingProps
    }: ProgressBarIconProps = props;
    return (
      <div
        data-testid={dataTestId}
        ref={forwardedRef}
        className={clsx(consumerClassName, progressBarIconContainerCSS)}
        style={consumerStyle}
        {...remainingProps}
      >
        {children}
      </div>
    );
  },
);

(
  ProgressBarIcon as typeof ProgressBarIcon & { displayName: string }
).displayName = 'ProgressBar.Icon';
